import httpClient from "../utils/httpClient";


export const UpdatePassword = async (requestData) => {
    const response = await httpClient.post("/User/password/change", requestData);
    return response.data;
};
